import { render } from "./Cookies.vue?vue&type=template&id=c6930d16&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=ts"
export * from "./Cookies.vue?vue&type=script&lang=ts"

import "./Cookies.vue?vue&type=style&index=0&id=c6930d16&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c6930d16"

export default script